import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash"
import * as PhoneFormat from "phoneformat.js";
import {PhoneAndEmailFactoryService} from "../../services/phone-and-email-factory.service";

export class BringozPhoneFormComponent implements IController {
  form: any;
  phone: any;
  name: string;
  ngPlaceholder: string;
  noDuplicates: boolean;
  allowInvalid: boolean;
  isDisabled: boolean;
  isRequired: boolean;
  isEdit: boolean;
  onChange: Function;

  siteCountryCode: any;
  country: any;
  originalNumber: any;
  cleanPhone: any;

  constructor(private splitService, private phoneAndEmailFactoryService: PhoneAndEmailFactoryService) {
    this.siteCountryCode = this.splitService.getCountryCode();
  }

  // Notes:
  // PhoneFormat.countryForE164Number('+972545242820') // 'IL'
  // PhoneFormat.formatNumberForMobileDialing('IL', '+972545242820') // '054-524-2820'
  // PhoneFormat.formatE164('IL', '+972545242820'); // '+972545242820'
  // PhoneFormat.formatInternational('IL', '+972545242820'); // '+972 54-524-2820'
  // PhoneFormat.countryCodeToName('IL'); // 'Israel'

  $onInit() {
    if (!this.name) {
      this.name = 'bringozPhone';
    }

    if (this.isEdit) {
      this.originalNumber = angular.copy(this.phone);
    }

    this.country = (this.phone ? PhoneFormat.countryForE164Number(this.phone) : this.siteCountryCode) || this.siteCountryCode;
    if (this.phone) {
      this._setCleanPhone(this.phone);
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.phone && !changes.phone.isFirstChange()) {
      if (this.phone) {
        this.country = PhoneFormat.countryForE164Number(this.phone) || this.country;
        this._validatePhone(this.phone);
      } else {
        this.cleanPhone = undefined;
      }
    }
  }

  onCountryChange(countryCode) {
    this.country = countryCode;
    this._validatePhone(this.phone);
  }

  onPhoneChange(cleanPhone, form) {
    this.cleanPhone = cleanPhone ? cleanPhone.replace(/[.*+?^@${}()|[\]\\A-Za-z]/g, '') : cleanPhone;
    const phone164 = this.cleanPhone ? PhoneFormat.formatE164(this.country, this.cleanPhone) : this.cleanPhone;
    this.onChange({phone: phone164, form: form});
  }

  private _setCleanPhone(phone) {
    const updatedClearPhone = PhoneFormat.formatLocal(this.country, phone);
    if (!_.isEqual(this.cleanPhone, updatedClearPhone)) {
      this.cleanPhone = updatedClearPhone;
    }
  }

  private _validatePhone(phone) {

    if (!!this.allowInvalid) {
      this.form[this.name].$setValidity('valid', true);
      this._setCleanPhone(phone);
    } else {
      this.phoneAndEmailFactoryService.phoneValidation(phone, this.country)
        .then((res) => {
          this.form[this.name].$setValidity('valid', res.isValid);
          if (res.isValid) {
            this._setCleanPhone(phone);
            // this._setCleanPhone(res.phoneNumber);

            if (!!this.noDuplicates && (!this.originalNumber || !_.isEqual(this.originalNumber, phone))) {
              this._validateExistPhone(phone);
            }
          }
        })
        .catch((error) => {
          this.form[this.name].$setValidity('valid', false);
        })
    }

  }

  private _validateExistPhone(phone) {
    this.phoneAndEmailFactoryService.phoneExistValidation(phone, this.country)
      .then((isExists) => {
        this.form[this.name].$setValidity('exists', isExists);
      })
  }

}


angular
  .module('bringoz.admin.commons')
  .component('bringozPhoneForm', {
    require: {
      form: '^form'
    },
    bindings: {
      phone: '<',
      name: '@?',
      ngPlaceholder: '@?',
      allowInvalid: '<?',
      noDuplicates: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      isEdit: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-phone-form/bringoz-phone-form.html',
    controller: BringozPhoneFormComponent
  });
